import { organization, ORGANIZATION_ID } from './organization';
import { servicesFaqItems } from './servicesFaqData';

const service = {
  '@type': 'Service',
  name: 'Software Development & Digital Product Design',
  description:
    'Boldare designs and builds digital products end to end — software development, UX/UI and product design, AI integration, legacy modernization, and dedicated teams — for scale-ups and enterprises.',
  provider: { '@id': ORGANIZATION_ID },
  areaServed: ['Europe', 'United States'],
  serviceType: ['Software Development', 'Digital Product Design'],
};

const faqPage = {
  '@type': 'FAQPage',
  mainEntity: servicesFaqItems.map(item => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export const services = {
  '@context': 'https://schema.org',
  '@graph': [organization, service, faqPage],
};
